import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileSave = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "file_save",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_575_3523",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 32,
			height: 32,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 32,
				height: 32,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_575_3523)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "file_save_2",
				d: "M23.9998 27.5255L28.8587 22.6666L27.4665 21.2743L24.9998 23.741V17.7H22.9998V23.741L20.5331 21.2743L19.1409 22.6666L23.9998 27.5255ZM18.9998 31.6666V29.6666H28.9998V31.6666H18.9998ZM8.07674 26.3333C7.42034 26.3333 6.85453 26.0957 6.3793 25.6205C5.9041 25.1452 5.6665 24.5794 5.6665 23.923V5.41023C5.6665 4.75383 5.9041 4.18802 6.3793 3.7128C6.85453 3.2376 7.42034 3 8.07674 3H17.3331L24.9998 10.6666V14.7769H22.9998V11.6666H16.3332V4.9999H8.07674C7.97416 4.9999 7.88014 5.04264 7.79467 5.12813C7.70918 5.2136 7.66644 5.30762 7.66644 5.4102V23.923C7.66644 24.0256 7.70918 24.1196 7.79467 24.2051C7.88014 24.2906 7.97416 24.3333 8.07674 24.3333H16.0767V26.3332L8.07674 26.3333Z",
				fill: "currentColor"
			})
		})]
	})]
});
export default SvgFileSave;
